import React from 'react';
import { Box, Tooltip, TooltipProps, Typography, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const DARK_BG = '#414C60';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: DARK_BG,
    borderRadius: 8,
    padding: '8px 12px',
    maxWidth: 170,
    boxShadow: '0px 1px 4px rgba(12, 12, 13, 0.1), 0px 1px 4px rgba(12, 12, 13, 0.05)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: DARK_BG,
  },
}));

export interface InfoTooltipProps {
  title: string;
  description: string;
  placement?: TooltipProps['placement'];
  children: TooltipProps['children'];
}

/**
 * Dark tooltip with a title and a description (Figma, 2026-10-15) for numbers that need explaining (e.g. a percentage).
 * Generic, reuse for any such hint. Line breaks in the description are kept.
 */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({ title, description, placement = 'top', children }) => (
  <StyledTooltip
    placement={placement}
    title={
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography sx={{ fontSize: 12, lineHeight: '14px', fontWeight: 600, color: '#fff' }}>{title}</Typography>
        <Typography sx={{ fontSize: 12, lineHeight: 1.4, fontWeight: 400, color: '#fff', whiteSpace: 'pre-line' }}>{description}</Typography>
      </Box>
    }
  >
    {children}
  </StyledTooltip>
);
